<template>
  <div class="CommentForm media align-items-center">
    <div class="media-body">
        <textarea 
          ref="commentInput"
          v-model="text"
          @keyup.enter="saveModel($event)"
          class="form-control" 
          placeholder="Write your comment" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
  export default {
    props: {
      baseModel: {
        type: Object,
        default: null
      }, 
      autofocus: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        text: ''
      };
    },
    computed: {
      ...mapState([
        'userId'
      ])
    },
    mounted() {
      if (this.baseModel) {
        this.text = this.baseModel.text;
      }

      if (this.autofocus) {
        this.$refs.commentInput.focus();
      }
    },
    methods: {
      saveModel(event) {
        const isValidComment = !!this.text.trim();
        if (isValidComment && !event.shiftKey) {
          const comment = this.baseModel || this.createEmptyCommentModel()
          comment.text = this.text;
          this.$emit('submitComment', comment);

          this.text = '';
        }
      },
      createEmptyCommentModel() {
        return {
          date: (new Date()).toISOString(),
          user: this.userId,
          userEmail: window.fbUser.email
        };
      }
    }
  }
</script>
<style>
</style>
